import axios from "axios";

import { User } from "../types/user";

export const getMe = async (): Promise<User> => {
  return (await axios.get("/api/v1/users/me")).data;
};

export const signIn = async (
  username: string,
  password: string,
): Promise<User> => {
  return (await axios.post("/api/v1/sessions", { username, password })).data;
};

export const signUp = async (
  username: string,
  password: string,
  withoutWorkspace?: boolean,
): Promise<User> => {
  return (
    await axios.post("/api/v1/users", {
      username,
      password,
      "without-workspace": withoutWorkspace,
    })
  ).data;
};
